import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import Vue from 'vue';
import Vuex from 'vuex'; // import the auto exporter

import modules from "./modules"; // import example from './modules'

Vue.use(Vuex);
/*
 * If not building with SSR mode, you can
 * directly export the Store instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Store instance.
 */

export default function ()
/* { ssrContext } */
{
  var Store = new Vuex.Store({
    modules: modules,
    actions: {
      resetAll: function resetAll(_ref) {
        var commit = _ref.commit;
        Object.keys(modules).forEach(function (moduleName) {
          commit("".concat(moduleName, "/RESET"));
        });
      }
    },
    // enable strict mode (adds overhead!)
    // for dev mode only
    strict: process.env.DEV
  });
  return Store;
}